import studyLabAcceptanceStatus from "@custom/rtk-apis/patients/labAcceptanceStatus";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const studyLabAcceptanceStatusSlice = createSlice({
  name: "studyLabAcceptanceStatusSlice",
  initialState,
  reducers: {
    resetLabPatientAcceptance : () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(studyLabAcceptanceStatus.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(studyLabAcceptanceStatus.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(studyLabAcceptanceStatus.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.status = "FAILED";
        state.result = payload;
        state.loading = false;
      });
  },
});

export default studyLabAcceptanceStatusSlice.reducer;
export const { resetLabPatientAcceptance } = studyLabAcceptanceStatusSlice.actions;
